import type { ReactNode } from "react";

import { ScrollRevealText } from "@/components/ui/scroll-reveal-text";
import { cn } from "@/lib/utils";

/**
 * Centered scroll-revealed section heading — the values / benefits / open-roles
 * band title on `/careers` (Figma 9117:51152). Callers own the surrounding
 * section padding; this owns the measure, alignment, and type scale.
 */
export function SectionRevealHeading({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "col-span-full mx-auto flex max-w-[320px] flex-col items-center py-4 text-center md:max-w-[720px] lg:max-w-[1120px] lg:py-6",
        className
      )}
    >
      <h2 className="text-ds-heading-h2 lg:text-ds-display-sm text-grey-950 font-normal text-balance">
        <ScrollRevealText variant="light">{children}</ScrollRevealText>
      </h2>
    </div>
  );
}
